<template>
    <div>
        <h4 v-if="title">{{title}}</h4>
        <div class="text-right">
            <button type="button" class="btn btn-link btn-primary" v-if="!show" @click="show = true">
                <i class="fas fa-search pointer"></i>
            </button>
            <button type="button" class="btn btn-link btn-primary" v-if="show" @click="reset">
                <i class="fas fa-times pointer"></i>
            </button>
        </div>

        <div v-if="show">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th v-if="showId">{{ $t('person.gridHeaders.id') }}</th>
                        <th>{{ $t('person.firstName') }}</th>
                        <th>{{ $t('person.middleName') }}</th>
                        <th>{{ $t('person.lastName') }}</th>
                        <th>{{ $t('person.egn') }}</th>
                        <th>{{ $t('person.gridHeaders.email') }}</th>
                        <th>{{ $t('person.position') }}</th>
                        <th>{{ $t('person.institution') }}</th>
                        <th>{{ $t('person.institutionLocation') }}</th>
                    </tr>
                </thead>
                <tbody class="bg-white">
                    <tr>
                        <td v-if="showId"></td>
                        <td>
                            <input type="text" class="form-control" v-model="searchModel.firstName"
                                   @input="onInput">
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="searchModel.middleName"
                                   @input="onInput">
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="searchModel.lastName"
                                   @input="onInput">
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="searchModel.identificationNumber"
                                   @input="onInput">
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="searchModel.email"
                                   @input="onInput">
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="searchModel.position"
                                   @input="onInput">
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="searchModel.institution"
                                   @input="onInput">
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="searchModel.institutionLocation"
                                   @input="onInput">
                        </td>
                    </tr>
                    <tr v-if="!isEmpty && (!searching && resultPeople.length < 1)">
                        <td colspan="8"><h5>{{ $t('searchDropdown.noResults') }}</h5></td>
                    </tr>

                    <tr v-if="searching">
                        <td colspan="8">
                            <div class="loader"></div>
                        </td>
                    </tr>
                    <tr v-else
                        class="pointer"
                        v-for="person in resultPeople"
                        :key="person.id"
                        @click="onPersonSelected($event, person)">
                        <td v-if="showId">{{ person.id }}</td>
                        <td>{{ person.firstName }}</td>
                        <td>{{ person.middleName }}</td>
                        <td>{{ person.lastName }}</td>
                        <td>{{ person.identificationNumber }}</td>
                        <td>{{ person.email }}</td>
                        <td>{{ person.position }}</td>
                        <td>{{ isEnVersion ? person.institutionEn : person.institution }}</td>
                        <td>{{ isEnVersion ? person.institutionLocationEn : person.institutionLocation }}</td>
                    </tr>
                    <div class="mb-3">
                        <div class="pagerInfoMessages pl-1" v-if="peopleFoundCount > 0 && resultPeople.length < peopleFoundCount">
                            {{ $t('person.notAllFoundRecordsDiplayed') }}
                        </div>
                        <div class="pagerInfo mr-1" v-if="peopleFoundCount > 0">
                            <span class="font-bold">{{ resultPeople.length }}</span> {{ $t('of') }} <span class="font-bold">{{ peopleFoundCount }}</span> {{ $tc('records',peopleFoundCount > 1 ? 2 : 1) }}
                        </div>
                    </div>
                </tbody>
            </table>

            <hr />
        </div>

    </div>
</template>

<script>
    import _ from 'lodash';
    import { Person, PersonSearchModel } from '../../models/models';
    import { PersonSearchType } from '../../models/enums';
    import personService from '../../services/person.service';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            value: {
                type: Person,
                required: false
            },
            title: String,
            personSearchType: {
                type: [Number, String],
                default: PersonSearchType.Person
            },
            showId: {
                type: Boolean,
                default: false
            },
            includeMergedProfiles: {
                type: Boolean,
                default: false
            }
        },
        components: {
        },
        data() {
            return {
                model: this.value,
                loading: false,
                show: false,
                searching: false,
                searchModel: new PersonSearchModel({
                    personSearchType: this.personSearchType,
                    includeMergedProfiles: this.includeMergedProfiles
                }),
                resultPeople: [],
                peopleFoundCount: null
            };
        },
        mounted() {
        },
        methods: {
            onInput() {
                if (this.searchModel.firstName.length > 0 || this.searchModel.middleName.length > 0
                    || this.searchModel.lastName.length > 0 || this.searchModel.identificationNumber.length > 0 || this.searchModel.email.length > 0
                    || this.searchModel.position.length > 0 || this.searchModel.institution.length > 0 || this.searchModel.institutionLocation.length > 0) {
                    this.search(this);
                } else {
                    this.resultPeople = [];
                    this.peopleFoundCount = null;
                }
            },
            search: _.debounce(vm => {
                vm.resultPeople = [];
                vm.searching = true;
                vm.$emit('searching');

                vm.$http.post('/api/search/person', vm.searchModel).then(result => {
                    vm.resultPeople = [];
                    if (result) {
                        vm.resultPeople = result.data.people;
                        vm.peopleFoundCount = result.data.peopleFoundCount;
                    }
                }).catch(error => {

                }).then(() => { vm.searching = false; vm.$emit('stopSearching'); });
            }, 350),
            getPersonData(id) {
                return new Promise((resolve, reject) => {
                    personService
                        .getById(id)
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' +
                                    this.$helpers.errorStatusCode(error)
                                ),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });

                            reject(error);
                        });
                });
            },
            onPersonSelected(event, selectedPerson) {
                if (!this.model || !selectedPerson.id) {
                    return;
                }

                this.getPersonData(selectedPerson.id)
                    .then(data => { this.populatePerson(data); this.clearSearchModel(); this.clearResultModel(); })
                    .catch()
                    .then(() => { this.show = false; });
            },
            populatePerson(p) {
                this.model.id = p.id;
                this.model.firstName = p.firstName;
                this.model.middleName = p.middleName;
                this.model.lastName = p.lastName;
                // TODO: Защо от service не идва PersonIdentificationModel а нещо друго?
                // this.person.personIdentification = new PersonIdentification(p.personIdentification)
                if (p.personIdentification) {
                    this.model.personIdentification.identificationTypeId =
                        p.personIdentification.identificationTypeId;
                    this.model.personIdentification.number =
                        p.personIdentification.number;
                    this.model.personIdentification.id = p.personIdentification.id;
                } else {
                    this.model.personIdentification.identificationTypeId = '';
                    this.model.personIdentification.number = '';
                    this.model.personIdentification.id = '';
                }
                this.model.genderTypeId = p.genderTypeId;
                this.model.phone = p.phone;
                this.model.mobilePhone = p.mobilePhone;
                this.model.email = p.email;
                this.model.positionId = p.positionId;
                this.model.position = p.position;
                this.model.description = p.description;
                this.model.userId = p.userId;
                this.model.idCardNumber = p.idCardNumber;
                this.model.idCardDateOfIssue = p.idCardDateOfIssue;
                this.model.idCardIssuedBy = p.idCardIssuedBy;
                this.model.positionStr = p.positionStr;
                this.model.positionStatisticId = p.positionStatisticId;
                this.model.salutationId = p.salutationId;
                this.model.educationDegreeId = p.educationDegreeId;
                this.model.titleDegreeId = p.titleDegreeId;
                this.model.institutionRegisterId = p.institutionRegisterId;
                this.model.relatedUsername = p.relatedUsername;
                this.model.relatedUserEmail = p.relatedUserEmail;

                this.model.specifyInstitution = p.specifyInstitution;
                this.model.institutionOther = p.institutionOther;
                this.model.institutionOtherCountryId = p.institutionOtherCountryId;
                this.model.institutionOtherCityId = p.institutionOtherCityId;
                this.model.institutionOtherCity = p.institutionOtherCity;
                this.model.address = p.address;
            },
            clearSearchModel() {
                this.searchModel = new PersonSearchModel({
                    personSearchType: this.personSearchType,
                    includeMergedProfiles: this.includeMergedProfiles
                })
            },
            clearResultModel() {
                this.resultPeople = [];
                this.peopleFoundCount = null;
            },
            reset() {
                this.clearSearchModel();
                this.clearResultModel();
                this.show = false;
                this.searching = false;
            }
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.$set(this.$data, 'model', this.value)
                }
            },
        },
        computed: {
            ...mapGetters(['isEnVersion']),
            isEmpty() {
                return this.searchModel.firstName.length < 1 && this.searchModel.middleName.length < 1 && this.searchModel.lastName.length < 1
                    && this.searchModel.identificationNumber.length < 1 && this.searchModel.email.length < 1 && this.searchModel.position.length < 1
                    && this.searchModel.institution.length < 1;
            }
        }
    };
</script>

<style scoped>
    .pagerInfo {
        position: absolute;
        right: 0;
        color: rgba(0,0,0,0.54);
    }

    .pagerInfoMessages {
        color: rgba(0,0,0,0.54);
        position: absolute;
    }

    .pb-1 {
        padding-bottom: 1rem !important;
    }

    .mr-1 {
        margin-right: 24px !important;
    }

    .pl-1 {
        padding-left: 12px !important;
    }

    .font-bold {
        font-weight: bold;
    }
</style>
